var $87c43a515e8f090f$exports = {};
var $87c43a515e8f090f$var$Module = typeof $87c43a515e8f090f$var$Module != "undefined" ? $87c43a515e8f090f$var$Module : {};
var $87c43a515e8f090f$var$ENVIRONMENT_IS_WEB = true;
var $87c43a515e8f090f$var$ENVIRONMENT_IS_WORKER = false;
var $87c43a515e8f090f$var$Module = {
    onRuntimeInitialized: ()=>{
        $87c43a515e8f090f$var$Module.main();
    }
};
var $87c43a515e8f090f$var$arguments_ = [];
var $87c43a515e8f090f$var$thisProgram = "./this.program";
var $87c43a515e8f090f$var$_scriptName = typeof document != "undefined" ? document.currentScript?.src : undefined;
var $87c43a515e8f090f$var$scriptDirectory = "";
function $87c43a515e8f090f$var$locateFile(path) {
    if ($87c43a515e8f090f$var$Module["locateFile"]) return $87c43a515e8f090f$var$Module["locateFile"](path, $87c43a515e8f090f$var$scriptDirectory);
    return $87c43a515e8f090f$var$scriptDirectory + path;
}
var $87c43a515e8f090f$var$readAsync, $87c43a515e8f090f$var$readBinary;
if ($87c43a515e8f090f$var$ENVIRONMENT_IS_WEB || $87c43a515e8f090f$var$ENVIRONMENT_IS_WORKER) {
    try {
        $87c43a515e8f090f$var$scriptDirectory = new URL(".", $87c43a515e8f090f$var$_scriptName).href;
    } catch  {}
    $87c43a515e8f090f$var$readAsync = async (url)=>{
        var response = await fetch(url, {
            credentials: "same-origin"
        });
        if (response.ok) return response.arrayBuffer();
        throw new Error(response.status + " : " + response.url);
    };
}
var $87c43a515e8f090f$var$out = console.log.bind(console);
var $87c43a515e8f090f$var$err = console.error.bind(console);
var $87c43a515e8f090f$var$wasmBinary;
var $87c43a515e8f090f$var$ABORT = false;
var $87c43a515e8f090f$var$wasmMemory;
var $87c43a515e8f090f$var$HEAP8, $87c43a515e8f090f$var$HEAPU8, $87c43a515e8f090f$var$HEAP16, $87c43a515e8f090f$var$HEAPU16, $87c43a515e8f090f$var$HEAP32, $87c43a515e8f090f$var$HEAPU32, $87c43a515e8f090f$var$HEAPF32, $87c43a515e8f090f$var$HEAPF64;
var $87c43a515e8f090f$var$HEAP64, $87c43a515e8f090f$var$HEAPU64;
var $87c43a515e8f090f$var$runtimeInitialized = false;
function $87c43a515e8f090f$var$updateMemoryViews() {
    var b = $87c43a515e8f090f$var$wasmMemory.buffer;
    $87c43a515e8f090f$var$HEAP8 = new Int8Array(b);
    $87c43a515e8f090f$var$HEAP16 = new Int16Array(b);
    $87c43a515e8f090f$var$HEAPU8 = new Uint8Array(b);
    $87c43a515e8f090f$var$HEAPU16 = new Uint16Array(b);
    $87c43a515e8f090f$var$HEAP32 = new Int32Array(b);
    $87c43a515e8f090f$var$HEAPU32 = new Uint32Array(b);
    $87c43a515e8f090f$var$HEAPF32 = new Float32Array(b);
    $87c43a515e8f090f$var$HEAPF64 = new Float64Array(b);
    $87c43a515e8f090f$var$HEAP64 = new BigInt64Array(b);
    $87c43a515e8f090f$var$HEAPU64 = new BigUint64Array(b);
}
function $87c43a515e8f090f$var$preRun() {
    if ($87c43a515e8f090f$var$Module["preRun"]) {
        if (typeof $87c43a515e8f090f$var$Module["preRun"] == "function") $87c43a515e8f090f$var$Module["preRun"] = [
            $87c43a515e8f090f$var$Module["preRun"]
        ];
        while($87c43a515e8f090f$var$Module["preRun"].length)$87c43a515e8f090f$var$addOnPreRun($87c43a515e8f090f$var$Module["preRun"].shift());
    }
    $87c43a515e8f090f$var$callRuntimeCallbacks($87c43a515e8f090f$var$onPreRuns);
}
function $87c43a515e8f090f$var$initRuntime() {
    $87c43a515e8f090f$var$runtimeInitialized = true;
    $87c43a515e8f090f$var$wasmExports["__wasm_call_ctors"]();
}
function $87c43a515e8f090f$var$postRun() {
    if ($87c43a515e8f090f$var$Module["postRun"]) {
        if (typeof $87c43a515e8f090f$var$Module["postRun"] == "function") $87c43a515e8f090f$var$Module["postRun"] = [
            $87c43a515e8f090f$var$Module["postRun"]
        ];
        while($87c43a515e8f090f$var$Module["postRun"].length)$87c43a515e8f090f$var$addOnPostRun($87c43a515e8f090f$var$Module["postRun"].shift());
    }
    $87c43a515e8f090f$var$callRuntimeCallbacks($87c43a515e8f090f$var$onPostRuns);
}
var $87c43a515e8f090f$var$runDependencies = 0;
var $87c43a515e8f090f$var$dependenciesFulfilled = null;
function $87c43a515e8f090f$var$addRunDependency(id) {
    $87c43a515e8f090f$var$runDependencies++;
    $87c43a515e8f090f$var$Module["monitorRunDependencies"]?.($87c43a515e8f090f$var$runDependencies);
}
function $87c43a515e8f090f$var$removeRunDependency(id) {
    $87c43a515e8f090f$var$runDependencies--;
    $87c43a515e8f090f$var$Module["monitorRunDependencies"]?.($87c43a515e8f090f$var$runDependencies);
    if ($87c43a515e8f090f$var$runDependencies == 0) {
        if ($87c43a515e8f090f$var$dependenciesFulfilled) {
            var callback = $87c43a515e8f090f$var$dependenciesFulfilled;
            $87c43a515e8f090f$var$dependenciesFulfilled = null;
            callback();
        }
    }
}
function $87c43a515e8f090f$var$abort(what) {
    $87c43a515e8f090f$var$Module["onAbort"]?.(what);
    what = "Aborted(" + what + ")";
    $87c43a515e8f090f$var$err(what);
    $87c43a515e8f090f$var$ABORT = true;
    what += ". Build with -sASSERTIONS for more info.";
    var e = new WebAssembly.RuntimeError(what);
    throw e;
}
var $87c43a515e8f090f$var$wasmBinaryFile;
function $87c43a515e8f090f$var$findWasmBinary() {
    return $87c43a515e8f090f$var$locateFile("index.wasm");
}
function $87c43a515e8f090f$var$getBinarySync(file) {
    if (file == $87c43a515e8f090f$var$wasmBinaryFile && $87c43a515e8f090f$var$wasmBinary) return new Uint8Array($87c43a515e8f090f$var$wasmBinary);
    if ($87c43a515e8f090f$var$readBinary) return $87c43a515e8f090f$var$readBinary(file);
    throw "both async and sync fetching of the wasm failed";
}
async function $87c43a515e8f090f$var$getWasmBinary(binaryFile) {
    if (!$87c43a515e8f090f$var$wasmBinary) try {
        var response = await $87c43a515e8f090f$var$readAsync(binaryFile);
        return new Uint8Array(response);
    } catch  {}
    return $87c43a515e8f090f$var$getBinarySync(binaryFile);
}
async function $87c43a515e8f090f$var$instantiateArrayBuffer(binaryFile, imports) {
    try {
        var binary = await $87c43a515e8f090f$var$getWasmBinary(binaryFile);
        var instance = await WebAssembly.instantiate(binary, imports);
        return instance;
    } catch (reason) {
        $87c43a515e8f090f$var$err(`failed to asynchronously prepare wasm: ${reason}`);
        $87c43a515e8f090f$var$abort(reason);
    }
}
async function $87c43a515e8f090f$var$instantiateAsync(binary, binaryFile, imports) {
    if (!binary) try {
        var response = fetch(binaryFile, {
            credentials: "same-origin"
        });
        var instantiationResult = await WebAssembly.instantiateStreaming(response, imports);
        return instantiationResult;
    } catch (reason) {
        $87c43a515e8f090f$var$err(`wasm streaming compile failed: ${reason}`);
        $87c43a515e8f090f$var$err("falling back to ArrayBuffer instantiation");
    }
    return $87c43a515e8f090f$var$instantiateArrayBuffer(binaryFile, imports);
}
function $87c43a515e8f090f$var$getWasmImports() {
    return {
        env: $87c43a515e8f090f$var$wasmImports,
        wasi_snapshot_preview1: $87c43a515e8f090f$var$wasmImports
    };
}
async function $87c43a515e8f090f$var$createWasm() {
    function receiveInstance(instance, module) {
        $87c43a515e8f090f$var$wasmExports = instance.exports;
        $87c43a515e8f090f$var$wasmMemory = $87c43a515e8f090f$var$wasmExports["memory"];
        $87c43a515e8f090f$var$updateMemoryViews();
        $87c43a515e8f090f$var$wasmTable = $87c43a515e8f090f$var$wasmExports["__indirect_function_table"];
        $87c43a515e8f090f$var$assignWasmExports($87c43a515e8f090f$var$wasmExports);
        $87c43a515e8f090f$var$removeRunDependency("wasm-instantiate");
        return $87c43a515e8f090f$var$wasmExports;
    }
    $87c43a515e8f090f$var$addRunDependency("wasm-instantiate");
    function receiveInstantiationResult(result) {
        return receiveInstance(result["instance"]);
    }
    var info = $87c43a515e8f090f$var$getWasmImports();
    if ($87c43a515e8f090f$var$Module["instantiateWasm"]) return new Promise((resolve, reject)=>{
        $87c43a515e8f090f$var$Module["instantiateWasm"](info, (mod, inst)=>{
            resolve(receiveInstance(mod, inst));
        });
    });
    $87c43a515e8f090f$var$wasmBinaryFile ??= $87c43a515e8f090f$var$findWasmBinary();
    var result = await $87c43a515e8f090f$var$instantiateAsync($87c43a515e8f090f$var$wasmBinary, $87c43a515e8f090f$var$wasmBinaryFile, info);
    var exports = receiveInstantiationResult(result);
    return exports;
}
class $87c43a515e8f090f$var$ExitStatus {
    name = "ExitStatus";
    constructor(status){
        this.message = `Program terminated with exit(${status})`;
        this.status = status;
    }
}
var $87c43a515e8f090f$var$callRuntimeCallbacks = (callbacks)=>{
    while(callbacks.length > 0)callbacks.shift()($87c43a515e8f090f$var$Module);
};
var $87c43a515e8f090f$var$onPostRuns = [];
var $87c43a515e8f090f$var$addOnPostRun = (cb)=>$87c43a515e8f090f$var$onPostRuns.push(cb);
var $87c43a515e8f090f$var$onPreRuns = [];
var $87c43a515e8f090f$var$addOnPreRun = (cb)=>$87c43a515e8f090f$var$onPreRuns.push(cb);
var $87c43a515e8f090f$var$noExitRuntime = true;
class $87c43a515e8f090f$var$ExceptionInfo {
    constructor(excPtr){
        this.excPtr = excPtr;
        this.ptr = excPtr - 24;
    }
    set_type(type) {
        $87c43a515e8f090f$var$HEAPU32[this.ptr + 4 >> 2] = type;
    }
    get_type() {
        return $87c43a515e8f090f$var$HEAPU32[this.ptr + 4 >> 2];
    }
    set_destructor(destructor) {
        $87c43a515e8f090f$var$HEAPU32[this.ptr + 8 >> 2] = destructor;
    }
    get_destructor() {
        return $87c43a515e8f090f$var$HEAPU32[this.ptr + 8 >> 2];
    }
    set_caught(caught) {
        caught = caught ? 1 : 0;
        $87c43a515e8f090f$var$HEAP8[this.ptr + 12] = caught;
    }
    get_caught() {
        return $87c43a515e8f090f$var$HEAP8[this.ptr + 12] != 0;
    }
    set_rethrown(rethrown) {
        rethrown = rethrown ? 1 : 0;
        $87c43a515e8f090f$var$HEAP8[this.ptr + 13] = rethrown;
    }
    get_rethrown() {
        return $87c43a515e8f090f$var$HEAP8[this.ptr + 13] != 0;
    }
    init(type, destructor) {
        this.set_adjusted_ptr(0);
        this.set_type(type);
        this.set_destructor(destructor);
    }
    set_adjusted_ptr(adjustedPtr) {
        $87c43a515e8f090f$var$HEAPU32[this.ptr + 16 >> 2] = adjustedPtr;
    }
    get_adjusted_ptr() {
        return $87c43a515e8f090f$var$HEAPU32[this.ptr + 16 >> 2];
    }
}
var $87c43a515e8f090f$var$exceptionLast = 0;
var $87c43a515e8f090f$var$uncaughtExceptionCount = 0;
var $87c43a515e8f090f$var$___cxa_throw = (ptr, type, destructor)=>{
    var info = new $87c43a515e8f090f$var$ExceptionInfo(ptr);
    info.init(type, destructor);
    $87c43a515e8f090f$var$exceptionLast = ptr;
    $87c43a515e8f090f$var$uncaughtExceptionCount++;
    throw $87c43a515e8f090f$var$exceptionLast;
};
var $87c43a515e8f090f$var$__abort_js = ()=>$87c43a515e8f090f$var$abort("");
var $87c43a515e8f090f$var$AsciiToString = (ptr)=>{
    var str = "";
    while(true){
        var ch = $87c43a515e8f090f$var$HEAPU8[ptr++];
        if (!ch) return str;
        str += String.fromCharCode(ch);
    }
};
var $87c43a515e8f090f$var$awaitingDependencies = {};
var $87c43a515e8f090f$var$registeredTypes = {};
var $87c43a515e8f090f$var$typeDependencies = {};
var $87c43a515e8f090f$var$BindingError = class BindingError extends Error {
    constructor(message){
        super(message);
        this.name = "BindingError";
    }
};
var $87c43a515e8f090f$var$throwBindingError = (message)=>{
    throw new $87c43a515e8f090f$var$BindingError(message);
};
function $87c43a515e8f090f$var$sharedRegisterType(rawType, registeredInstance, options = {}) {
    var name = registeredInstance.name;
    if (!rawType) $87c43a515e8f090f$var$throwBindingError(`type "${name}" must have a positive integer typeid pointer`);
    if ($87c43a515e8f090f$var$registeredTypes.hasOwnProperty(rawType)) {
        if (options.ignoreDuplicateRegistrations) return;
        else $87c43a515e8f090f$var$throwBindingError(`Cannot register type '${name}' twice`);
    }
    $87c43a515e8f090f$var$registeredTypes[rawType] = registeredInstance;
    delete $87c43a515e8f090f$var$typeDependencies[rawType];
    if ($87c43a515e8f090f$var$awaitingDependencies.hasOwnProperty(rawType)) {
        var callbacks = $87c43a515e8f090f$var$awaitingDependencies[rawType];
        delete $87c43a515e8f090f$var$awaitingDependencies[rawType];
        callbacks.forEach((cb)=>cb());
    }
}
function $87c43a515e8f090f$var$registerType(rawType, registeredInstance, options = {}) {
    return $87c43a515e8f090f$var$sharedRegisterType(rawType, registeredInstance, options);
}
var $87c43a515e8f090f$var$integerReadValueFromPointer = (name, width, signed)=>{
    switch(width){
        case 1:
            return signed ? (pointer)=>$87c43a515e8f090f$var$HEAP8[pointer] : (pointer)=>$87c43a515e8f090f$var$HEAPU8[pointer];
        case 2:
            return signed ? (pointer)=>$87c43a515e8f090f$var$HEAP16[pointer >> 1] : (pointer)=>$87c43a515e8f090f$var$HEAPU16[pointer >> 1];
        case 4:
            return signed ? (pointer)=>$87c43a515e8f090f$var$HEAP32[pointer >> 2] : (pointer)=>$87c43a515e8f090f$var$HEAPU32[pointer >> 2];
        case 8:
            return signed ? (pointer)=>$87c43a515e8f090f$var$HEAP64[pointer >> 3] : (pointer)=>$87c43a515e8f090f$var$HEAPU64[pointer >> 3];
        default:
            throw new TypeError(`invalid integer width (${width}): ${name}`);
    }
};
var $87c43a515e8f090f$var$__embind_register_bigint = (primitiveType, name, size, minRange, maxRange)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    const isUnsignedType = minRange === 0n;
    let fromWireType = (value)=>value;
    if (isUnsignedType) {
        const bitSize = size * 8;
        fromWireType = (value)=>BigInt.asUintN(bitSize, value);
        maxRange = fromWireType(maxRange);
    }
    $87c43a515e8f090f$var$registerType(primitiveType, {
        name: name,
        fromWireType: fromWireType,
        toWireType: (destructors, value)=>{
            if (typeof value == "number") value = BigInt(value);
            return value;
        },
        readValueFromPointer: $87c43a515e8f090f$var$integerReadValueFromPointer(name, size, !isUnsignedType),
        destructorFunction: null
    });
};
var $87c43a515e8f090f$var$__embind_register_bool = (rawType, name, trueValue, falseValue)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    $87c43a515e8f090f$var$registerType(rawType, {
        name: name,
        fromWireType: function(wt) {
            return !!wt;
        },
        toWireType: function(destructors, o) {
            return o ? trueValue : falseValue;
        },
        readValueFromPointer: function(pointer) {
            return this.fromWireType($87c43a515e8f090f$var$HEAPU8[pointer]);
        },
        destructorFunction: null
    });
};
var $87c43a515e8f090f$var$shallowCopyInternalPointer = (o)=>({
        count: o.count,
        deleteScheduled: o.deleteScheduled,
        preservePointerOnDelete: o.preservePointerOnDelete,
        ptr: o.ptr,
        ptrType: o.ptrType,
        smartPtr: o.smartPtr,
        smartPtrType: o.smartPtrType
    });
var $87c43a515e8f090f$var$throwInstanceAlreadyDeleted = (obj)=>{
    function getInstanceTypeName(handle) {
        return handle.$$.ptrType.registeredClass.name;
    }
    $87c43a515e8f090f$var$throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
};
var $87c43a515e8f090f$var$finalizationRegistry = false;
var $87c43a515e8f090f$var$detachFinalizer = (handle)=>{};
var $87c43a515e8f090f$var$runDestructor = ($$)=>{
    if ($$.smartPtr) $$.smartPtrType.rawDestructor($$.smartPtr);
    else $$.ptrType.registeredClass.rawDestructor($$.ptr);
};
var $87c43a515e8f090f$var$releaseClassHandle = ($$)=>{
    $$.count.value -= 1;
    var toDelete = 0 === $$.count.value;
    if (toDelete) $87c43a515e8f090f$var$runDestructor($$);
};
var $87c43a515e8f090f$var$attachFinalizer = (handle)=>{
    if ("undefined" === typeof FinalizationRegistry) {
        $87c43a515e8f090f$var$attachFinalizer = (handle)=>handle;
        return handle;
    }
    $87c43a515e8f090f$var$finalizationRegistry = new FinalizationRegistry((info)=>{
        $87c43a515e8f090f$var$releaseClassHandle(info.$$);
    });
    $87c43a515e8f090f$var$attachFinalizer = (handle)=>{
        var $$ = handle.$$;
        var hasSmartPtr = !!$$.smartPtr;
        if (hasSmartPtr) {
            var info = {
                $$: $$
            };
            $87c43a515e8f090f$var$finalizationRegistry.register(handle, info, handle);
        }
        return handle;
    };
    $87c43a515e8f090f$var$detachFinalizer = (handle)=>$87c43a515e8f090f$var$finalizationRegistry.unregister(handle);
    return $87c43a515e8f090f$var$attachFinalizer(handle);
};
var $87c43a515e8f090f$var$deletionQueue = [];
var $87c43a515e8f090f$var$flushPendingDeletes = ()=>{
    while($87c43a515e8f090f$var$deletionQueue.length){
        var obj = $87c43a515e8f090f$var$deletionQueue.pop();
        obj.$$.deleteScheduled = false;
        obj["delete"]();
    }
};
var $87c43a515e8f090f$var$delayFunction;
var $87c43a515e8f090f$var$init_ClassHandle = ()=>{
    let proto = $87c43a515e8f090f$var$ClassHandle.prototype;
    Object.assign(proto, {
        isAliasOf (other) {
            if (!(this instanceof $87c43a515e8f090f$var$ClassHandle)) return false;
            if (!(other instanceof $87c43a515e8f090f$var$ClassHandle)) return false;
            var leftClass = this.$$.ptrType.registeredClass;
            var left = this.$$.ptr;
            other.$$ = other.$$;
            var rightClass = other.$$.ptrType.registeredClass;
            var right = other.$$.ptr;
            while(leftClass.baseClass){
                left = leftClass.upcast(left);
                leftClass = leftClass.baseClass;
            }
            while(rightClass.baseClass){
                right = rightClass.upcast(right);
                rightClass = rightClass.baseClass;
            }
            return leftClass === rightClass && left === right;
        },
        clone () {
            if (!this.$$.ptr) $87c43a515e8f090f$var$throwInstanceAlreadyDeleted(this);
            if (this.$$.preservePointerOnDelete) {
                this.$$.count.value += 1;
                return this;
            } else {
                var clone = $87c43a515e8f090f$var$attachFinalizer(Object.create(Object.getPrototypeOf(this), {
                    $$: {
                        value: $87c43a515e8f090f$var$shallowCopyInternalPointer(this.$$)
                    }
                }));
                clone.$$.count.value += 1;
                clone.$$.deleteScheduled = false;
                return clone;
            }
        },
        delete () {
            if (!this.$$.ptr) $87c43a515e8f090f$var$throwInstanceAlreadyDeleted(this);
            if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) $87c43a515e8f090f$var$throwBindingError("Object already scheduled for deletion");
            $87c43a515e8f090f$var$detachFinalizer(this);
            $87c43a515e8f090f$var$releaseClassHandle(this.$$);
            if (!this.$$.preservePointerOnDelete) {
                this.$$.smartPtr = undefined;
                this.$$.ptr = undefined;
            }
        },
        isDeleted () {
            return !this.$$.ptr;
        },
        deleteLater () {
            if (!this.$$.ptr) $87c43a515e8f090f$var$throwInstanceAlreadyDeleted(this);
            if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) $87c43a515e8f090f$var$throwBindingError("Object already scheduled for deletion");
            $87c43a515e8f090f$var$deletionQueue.push(this);
            if ($87c43a515e8f090f$var$deletionQueue.length === 1 && $87c43a515e8f090f$var$delayFunction) $87c43a515e8f090f$var$delayFunction($87c43a515e8f090f$var$flushPendingDeletes);
            this.$$.deleteScheduled = true;
            return this;
        }
    });
    const symbolDispose = Symbol.dispose;
    if (symbolDispose) proto[symbolDispose] = proto["delete"];
};
function $87c43a515e8f090f$var$ClassHandle() {}
var $87c43a515e8f090f$var$createNamedFunction = (name, func)=>Object.defineProperty(func, "name", {
        value: name
    });
var $87c43a515e8f090f$var$registeredPointers = {};
var $87c43a515e8f090f$var$ensureOverloadTable = (proto, methodName, humanName)=>{
    if (undefined === proto[methodName].overloadTable) {
        var prevFunc = proto[methodName];
        proto[methodName] = function(...args) {
            if (!proto[methodName].overloadTable.hasOwnProperty(args.length)) $87c43a515e8f090f$var$throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${args.length}) - expects one of (${proto[methodName].overloadTable})!`);
            return proto[methodName].overloadTable[args.length].apply(this, args);
        };
        proto[methodName].overloadTable = [];
        proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
    }
};
var $87c43a515e8f090f$var$exposePublicSymbol = (name, value, numArguments)=>{
    if ($87c43a515e8f090f$var$Module.hasOwnProperty(name)) {
        if (undefined === numArguments || undefined !== $87c43a515e8f090f$var$Module[name].overloadTable && undefined !== $87c43a515e8f090f$var$Module[name].overloadTable[numArguments]) $87c43a515e8f090f$var$throwBindingError(`Cannot register public name '${name}' twice`);
        $87c43a515e8f090f$var$ensureOverloadTable($87c43a515e8f090f$var$Module, name, name);
        if ($87c43a515e8f090f$var$Module[name].overloadTable.hasOwnProperty(numArguments)) $87c43a515e8f090f$var$throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);
        $87c43a515e8f090f$var$Module[name].overloadTable[numArguments] = value;
    } else {
        $87c43a515e8f090f$var$Module[name] = value;
        $87c43a515e8f090f$var$Module[name].argCount = numArguments;
    }
};
var $87c43a515e8f090f$var$char_0 = 48;
var $87c43a515e8f090f$var$char_9 = 57;
var $87c43a515e8f090f$var$makeLegalFunctionName = (name)=>{
    name = name.replace(/[^a-zA-Z0-9_]/g, "$");
    var f = name.charCodeAt(0);
    if (f >= $87c43a515e8f090f$var$char_0 && f <= $87c43a515e8f090f$var$char_9) return `_${name}`;
    return name;
};
function $87c43a515e8f090f$var$RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
    this.name = name;
    this.constructor = constructor;
    this.instancePrototype = instancePrototype;
    this.rawDestructor = rawDestructor;
    this.baseClass = baseClass;
    this.getActualType = getActualType;
    this.upcast = upcast;
    this.downcast = downcast;
    this.pureVirtualFunctions = [];
}
var $87c43a515e8f090f$var$upcastPointer = (ptr, ptrClass, desiredClass)=>{
    while(ptrClass !== desiredClass){
        if (!ptrClass.upcast) $87c43a515e8f090f$var$throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);
        ptr = ptrClass.upcast(ptr);
        ptrClass = ptrClass.baseClass;
    }
    return ptr;
};
var $87c43a515e8f090f$var$embindRepr = (v)=>{
    if (v === null) return "null";
    var t = typeof v;
    if (t === "object" || t === "array" || t === "function") return v.toString();
    else return "" + v;
};
function $87c43a515e8f090f$var$constNoSmartPtrRawPointerToWireType(destructors, handle) {
    if (handle === null) {
        if (this.isReference) $87c43a515e8f090f$var$throwBindingError(`null is not a valid ${this.name}`);
        return 0;
    }
    if (!handle.$$) $87c43a515e8f090f$var$throwBindingError(`Cannot pass "${$87c43a515e8f090f$var$embindRepr(handle)}" as a ${this.name}`);
    if (!handle.$$.ptr) $87c43a515e8f090f$var$throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
    var handleClass = handle.$$.ptrType.registeredClass;
    var ptr = $87c43a515e8f090f$var$upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
    return ptr;
}
function $87c43a515e8f090f$var$genericPointerToWireType(destructors, handle) {
    var ptr;
    if (handle === null) {
        if (this.isReference) $87c43a515e8f090f$var$throwBindingError(`null is not a valid ${this.name}`);
        if (this.isSmartPointer) {
            ptr = this.rawConstructor();
            if (destructors !== null) destructors.push(this.rawDestructor, ptr);
            return ptr;
        } else return 0;
    }
    if (!handle || !handle.$$) $87c43a515e8f090f$var$throwBindingError(`Cannot pass "${$87c43a515e8f090f$var$embindRepr(handle)}" as a ${this.name}`);
    if (!handle.$$.ptr) $87c43a515e8f090f$var$throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
    if (!this.isConst && handle.$$.ptrType.isConst) $87c43a515e8f090f$var$throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
    var handleClass = handle.$$.ptrType.registeredClass;
    ptr = $87c43a515e8f090f$var$upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
    if (this.isSmartPointer) {
        if (undefined === handle.$$.smartPtr) $87c43a515e8f090f$var$throwBindingError("Passing raw pointer to smart pointer is illegal");
        switch(this.sharingPolicy){
            case 0:
                if (handle.$$.smartPtrType === this) ptr = handle.$$.smartPtr;
                else $87c43a515e8f090f$var$throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                break;
            case 1:
                ptr = handle.$$.smartPtr;
                break;
            case 2:
                if (handle.$$.smartPtrType === this) ptr = handle.$$.smartPtr;
                else {
                    var clonedHandle = handle["clone"]();
                    ptr = this.rawShare(ptr, $87c43a515e8f090f$var$Emval.toHandle(()=>clonedHandle["delete"]()));
                    if (destructors !== null) destructors.push(this.rawDestructor, ptr);
                }
                break;
            default:
                $87c43a515e8f090f$var$throwBindingError("Unsupporting sharing policy");
        }
    }
    return ptr;
}
function $87c43a515e8f090f$var$nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
    if (handle === null) {
        if (this.isReference) $87c43a515e8f090f$var$throwBindingError(`null is not a valid ${this.name}`);
        return 0;
    }
    if (!handle.$$) $87c43a515e8f090f$var$throwBindingError(`Cannot pass "${$87c43a515e8f090f$var$embindRepr(handle)}" as a ${this.name}`);
    if (!handle.$$.ptr) $87c43a515e8f090f$var$throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
    if (handle.$$.ptrType.isConst) $87c43a515e8f090f$var$throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);
    var handleClass = handle.$$.ptrType.registeredClass;
    var ptr = $87c43a515e8f090f$var$upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
    return ptr;
}
function $87c43a515e8f090f$var$readPointer(pointer) {
    return this.fromWireType($87c43a515e8f090f$var$HEAPU32[pointer >> 2]);
}
var $87c43a515e8f090f$var$downcastPointer = (ptr, ptrClass, desiredClass)=>{
    if (ptrClass === desiredClass) return ptr;
    if (undefined === desiredClass.baseClass) return null;
    var rv = $87c43a515e8f090f$var$downcastPointer(ptr, ptrClass, desiredClass.baseClass);
    if (rv === null) return null;
    return desiredClass.downcast(rv);
};
var $87c43a515e8f090f$var$registeredInstances = {};
var $87c43a515e8f090f$var$getBasestPointer = (class_, ptr)=>{
    if (ptr === undefined) $87c43a515e8f090f$var$throwBindingError("ptr should not be undefined");
    while(class_.baseClass){
        ptr = class_.upcast(ptr);
        class_ = class_.baseClass;
    }
    return ptr;
};
var $87c43a515e8f090f$var$getInheritedInstance = (class_, ptr)=>{
    ptr = $87c43a515e8f090f$var$getBasestPointer(class_, ptr);
    return $87c43a515e8f090f$var$registeredInstances[ptr];
};
var $87c43a515e8f090f$var$InternalError = class InternalError extends Error {
    constructor(message){
        super(message);
        this.name = "InternalError";
    }
};
var $87c43a515e8f090f$var$throwInternalError = (message)=>{
    throw new $87c43a515e8f090f$var$InternalError(message);
};
var $87c43a515e8f090f$var$makeClassHandle = (prototype, record)=>{
    if (!record.ptrType || !record.ptr) $87c43a515e8f090f$var$throwInternalError("makeClassHandle requires ptr and ptrType");
    var hasSmartPtrType = !!record.smartPtrType;
    var hasSmartPtr = !!record.smartPtr;
    if (hasSmartPtrType !== hasSmartPtr) $87c43a515e8f090f$var$throwInternalError("Both smartPtrType and smartPtr must be specified");
    record.count = {
        value: 1
    };
    return $87c43a515e8f090f$var$attachFinalizer(Object.create(prototype, {
        $$: {
            value: record,
            writable: true
        }
    }));
};
function $87c43a515e8f090f$var$RegisteredPointer_fromWireType(ptr) {
    var rawPointer = this.getPointee(ptr);
    if (!rawPointer) {
        this.destructor(ptr);
        return null;
    }
    var registeredInstance = $87c43a515e8f090f$var$getInheritedInstance(this.registeredClass, rawPointer);
    if (undefined !== registeredInstance) {
        if (0 === registeredInstance.$$.count.value) {
            registeredInstance.$$.ptr = rawPointer;
            registeredInstance.$$.smartPtr = ptr;
            return registeredInstance["clone"]();
        } else {
            var rv = registeredInstance["clone"]();
            this.destructor(ptr);
            return rv;
        }
    }
    function makeDefaultHandle() {
        if (this.isSmartPointer) return $87c43a515e8f090f$var$makeClassHandle(this.registeredClass.instancePrototype, {
            ptrType: this.pointeeType,
            ptr: rawPointer,
            smartPtrType: this,
            smartPtr: ptr
        });
        else return $87c43a515e8f090f$var$makeClassHandle(this.registeredClass.instancePrototype, {
            ptrType: this,
            ptr: ptr
        });
    }
    var actualType = this.registeredClass.getActualType(rawPointer);
    var registeredPointerRecord = $87c43a515e8f090f$var$registeredPointers[actualType];
    if (!registeredPointerRecord) return makeDefaultHandle.call(this);
    var toType;
    if (this.isConst) toType = registeredPointerRecord.constPointerType;
    else toType = registeredPointerRecord.pointerType;
    var dp = $87c43a515e8f090f$var$downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
    if (dp === null) return makeDefaultHandle.call(this);
    if (this.isSmartPointer) return $87c43a515e8f090f$var$makeClassHandle(toType.registeredClass.instancePrototype, {
        ptrType: toType,
        ptr: dp,
        smartPtrType: this,
        smartPtr: ptr
    });
    else return $87c43a515e8f090f$var$makeClassHandle(toType.registeredClass.instancePrototype, {
        ptrType: toType,
        ptr: dp
    });
}
var $87c43a515e8f090f$var$init_RegisteredPointer = ()=>{
    Object.assign($87c43a515e8f090f$var$RegisteredPointer.prototype, {
        getPointee (ptr) {
            if (this.rawGetPointee) ptr = this.rawGetPointee(ptr);
            return ptr;
        },
        destructor (ptr) {
            this.rawDestructor?.(ptr);
        },
        readValueFromPointer: $87c43a515e8f090f$var$readPointer,
        fromWireType: $87c43a515e8f090f$var$RegisteredPointer_fromWireType
    });
};
function $87c43a515e8f090f$var$RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
    this.name = name;
    this.registeredClass = registeredClass;
    this.isReference = isReference;
    this.isConst = isConst;
    this.isSmartPointer = isSmartPointer;
    this.pointeeType = pointeeType;
    this.sharingPolicy = sharingPolicy;
    this.rawGetPointee = rawGetPointee;
    this.rawConstructor = rawConstructor;
    this.rawShare = rawShare;
    this.rawDestructor = rawDestructor;
    if (!isSmartPointer && registeredClass.baseClass === undefined) {
        if (isConst) {
            this.toWireType = $87c43a515e8f090f$var$constNoSmartPtrRawPointerToWireType;
            this.destructorFunction = null;
        } else {
            this.toWireType = $87c43a515e8f090f$var$nonConstNoSmartPtrRawPointerToWireType;
            this.destructorFunction = null;
        }
    } else this.toWireType = $87c43a515e8f090f$var$genericPointerToWireType;
}
var $87c43a515e8f090f$var$replacePublicSymbol = (name, value, numArguments)=>{
    if (!$87c43a515e8f090f$var$Module.hasOwnProperty(name)) $87c43a515e8f090f$var$throwInternalError("Replacing nonexistent public symbol");
    if (undefined !== $87c43a515e8f090f$var$Module[name].overloadTable && undefined !== numArguments) $87c43a515e8f090f$var$Module[name].overloadTable[numArguments] = value;
    else {
        $87c43a515e8f090f$var$Module[name] = value;
        $87c43a515e8f090f$var$Module[name].argCount = numArguments;
    }
};
var $87c43a515e8f090f$var$wasmTableMirror = [];
var $87c43a515e8f090f$var$wasmTable;
var $87c43a515e8f090f$var$getWasmTableEntry = (funcPtr)=>{
    var func = $87c43a515e8f090f$var$wasmTableMirror[funcPtr];
    if (!func) $87c43a515e8f090f$var$wasmTableMirror[funcPtr] = func = $87c43a515e8f090f$var$wasmTable.get(funcPtr);
    return func;
};
var $87c43a515e8f090f$var$embind__requireFunction = (signature, rawFunction, isAsync = false)=>{
    signature = $87c43a515e8f090f$var$AsciiToString(signature);
    function makeDynCaller() {
        var rtn = $87c43a515e8f090f$var$getWasmTableEntry(rawFunction);
        return rtn;
    }
    var fp = makeDynCaller();
    if (typeof fp != "function") $87c43a515e8f090f$var$throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);
    return fp;
};
class $87c43a515e8f090f$var$UnboundTypeError extends Error {
}
var $87c43a515e8f090f$var$getTypeName = (type)=>{
    var ptr = $87c43a515e8f090f$var$___getTypeName(type);
    var rv = $87c43a515e8f090f$var$AsciiToString(ptr);
    $87c43a515e8f090f$var$_free(ptr);
    return rv;
};
var $87c43a515e8f090f$var$throwUnboundTypeError = (message, types)=>{
    var unboundTypes = [];
    var seen = {};
    function visit(type) {
        if (seen[type]) return;
        if ($87c43a515e8f090f$var$registeredTypes[type]) return;
        if ($87c43a515e8f090f$var$typeDependencies[type]) {
            $87c43a515e8f090f$var$typeDependencies[type].forEach(visit);
            return;
        }
        unboundTypes.push(type);
        seen[type] = true;
    }
    types.forEach(visit);
    throw new $87c43a515e8f090f$var$UnboundTypeError(`${message}: ` + unboundTypes.map($87c43a515e8f090f$var$getTypeName).join([
        ", "
    ]));
};
var $87c43a515e8f090f$var$whenDependentTypesAreResolved = (myTypes, dependentTypes, getTypeConverters)=>{
    myTypes.forEach((type)=>$87c43a515e8f090f$var$typeDependencies[type] = dependentTypes);
    function onComplete(typeConverters) {
        var myTypeConverters = getTypeConverters(typeConverters);
        if (myTypeConverters.length !== myTypes.length) $87c43a515e8f090f$var$throwInternalError("Mismatched type converter count");
        for(var i = 0; i < myTypes.length; ++i)$87c43a515e8f090f$var$registerType(myTypes[i], myTypeConverters[i]);
    }
    var typeConverters = new Array(dependentTypes.length);
    var unregisteredTypes = [];
    var registered = 0;
    dependentTypes.forEach((dt, i)=>{
        if ($87c43a515e8f090f$var$registeredTypes.hasOwnProperty(dt)) typeConverters[i] = $87c43a515e8f090f$var$registeredTypes[dt];
        else {
            unregisteredTypes.push(dt);
            if (!$87c43a515e8f090f$var$awaitingDependencies.hasOwnProperty(dt)) $87c43a515e8f090f$var$awaitingDependencies[dt] = [];
            $87c43a515e8f090f$var$awaitingDependencies[dt].push(()=>{
                typeConverters[i] = $87c43a515e8f090f$var$registeredTypes[dt];
                ++registered;
                if (registered === unregisteredTypes.length) onComplete(typeConverters);
            });
        }
    });
    if (0 === unregisteredTypes.length) onComplete(typeConverters);
};
var $87c43a515e8f090f$var$__embind_register_class = (rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    getActualType = $87c43a515e8f090f$var$embind__requireFunction(getActualTypeSignature, getActualType);
    upcast &&= $87c43a515e8f090f$var$embind__requireFunction(upcastSignature, upcast);
    downcast &&= $87c43a515e8f090f$var$embind__requireFunction(downcastSignature, downcast);
    rawDestructor = $87c43a515e8f090f$var$embind__requireFunction(destructorSignature, rawDestructor);
    var legalFunctionName = $87c43a515e8f090f$var$makeLegalFunctionName(name);
    $87c43a515e8f090f$var$exposePublicSymbol(legalFunctionName, function() {
        $87c43a515e8f090f$var$throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [
            baseClassRawType
        ]);
    });
    $87c43a515e8f090f$var$whenDependentTypesAreResolved([
        rawType,
        rawPointerType,
        rawConstPointerType
    ], baseClassRawType ? [
        baseClassRawType
    ] : [], (base)=>{
        base = base[0];
        var baseClass;
        var basePrototype;
        if (baseClassRawType) {
            baseClass = base.registeredClass;
            basePrototype = baseClass.instancePrototype;
        } else basePrototype = $87c43a515e8f090f$var$ClassHandle.prototype;
        var constructor = $87c43a515e8f090f$var$createNamedFunction(name, function(...args) {
            if (Object.getPrototypeOf(this) !== instancePrototype) throw new $87c43a515e8f090f$var$BindingError(`Use 'new' to construct ${name}`);
            if (undefined === registeredClass.constructor_body) throw new $87c43a515e8f090f$var$BindingError(`${name} has no accessible constructor`);
            var body = registeredClass.constructor_body[args.length];
            if (undefined === body) throw new $87c43a515e8f090f$var$BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${args.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);
            return body.apply(this, args);
        });
        var instancePrototype = Object.create(basePrototype, {
            constructor: {
                value: constructor
            }
        });
        constructor.prototype = instancePrototype;
        var registeredClass = new $87c43a515e8f090f$var$RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
        if (registeredClass.baseClass) {
            registeredClass.baseClass.__derivedClasses ??= [];
            registeredClass.baseClass.__derivedClasses.push(registeredClass);
        }
        var referenceConverter = new $87c43a515e8f090f$var$RegisteredPointer(name, registeredClass, true, false, false);
        var pointerConverter = new $87c43a515e8f090f$var$RegisteredPointer(name + "*", registeredClass, false, false, false);
        var constPointerConverter = new $87c43a515e8f090f$var$RegisteredPointer(name + " const*", registeredClass, false, true, false);
        $87c43a515e8f090f$var$registeredPointers[rawType] = {
            pointerType: pointerConverter,
            constPointerType: constPointerConverter
        };
        $87c43a515e8f090f$var$replacePublicSymbol(legalFunctionName, constructor);
        return [
            referenceConverter,
            pointerConverter,
            constPointerConverter
        ];
    });
};
var $87c43a515e8f090f$var$heap32VectorToArray = (count, firstElement)=>{
    var array = [];
    for(var i = 0; i < count; i++)array.push($87c43a515e8f090f$var$HEAPU32[firstElement + i * 4 >> 2]);
    return array;
};
var $87c43a515e8f090f$var$runDestructors = (destructors)=>{
    while(destructors.length){
        var ptr = destructors.pop();
        var del = destructors.pop();
        del(ptr);
    }
};
function $87c43a515e8f090f$var$usesDestructorStack(argTypes) {
    for(var i = 1; i < argTypes.length; ++i){
        if (argTypes[i] !== null && argTypes[i].destructorFunction === undefined) return true;
    }
    return false;
}
function $87c43a515e8f090f$var$createJsInvoker(argTypes, isClassMethodFunc, returns, isAsync) {
    var needsDestructorStack = $87c43a515e8f090f$var$usesDestructorStack(argTypes);
    var argCount = argTypes.length - 2;
    var argsList = [];
    var argsListWired = [
        "fn"
    ];
    if (isClassMethodFunc) argsListWired.push("thisWired");
    for(var i = 0; i < argCount; ++i){
        argsList.push(`arg${i}`);
        argsListWired.push(`arg${i}Wired`);
    }
    argsList = argsList.join(",");
    argsListWired = argsListWired.join(",");
    var invokerFnBody = `return function (${argsList}) {\n`;
    if (needsDestructorStack) invokerFnBody += "var destructors = [];\n";
    var dtorStack = needsDestructorStack ? "destructors" : "null";
    var args1 = [
        "humanName",
        "throwBindingError",
        "invoker",
        "fn",
        "runDestructors",
        "fromRetWire",
        "toClassParamWire"
    ];
    if (isClassMethodFunc) invokerFnBody += `var thisWired = toClassParamWire(${dtorStack}, this);\n`;
    for(var i = 0; i < argCount; ++i){
        var argName = `toArg${i}Wire`;
        invokerFnBody += `var arg${i}Wired = ${argName}(${dtorStack}, arg${i});\n`;
        args1.push(argName);
    }
    invokerFnBody += (returns || isAsync ? "var rv = " : "") + `invoker(${argsListWired});\n`;
    if (needsDestructorStack) invokerFnBody += "runDestructors(destructors);\n";
    else for(var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i){
        var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
        if (argTypes[i].destructorFunction !== null) {
            invokerFnBody += `${paramName}_dtor(${paramName});\n`;
            args1.push(`${paramName}_dtor`);
        }
    }
    if (returns) invokerFnBody += "var ret = fromRetWire(rv);\nreturn ret;\n";
    invokerFnBody += "}\n";
    return new Function(args1, invokerFnBody);
}
function $87c43a515e8f090f$var$craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, isAsync) {
    var argCount = argTypes.length;
    if (argCount < 2) $87c43a515e8f090f$var$throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
    var isClassMethodFunc = argTypes[1] !== null && classType !== null;
    var needsDestructorStack = $87c43a515e8f090f$var$usesDestructorStack(argTypes);
    var returns = !argTypes[0].isVoid;
    var retType = argTypes[0];
    var instType = argTypes[1];
    var closureArgs = [
        humanName,
        $87c43a515e8f090f$var$throwBindingError,
        cppInvokerFunc,
        cppTargetFunc,
        $87c43a515e8f090f$var$runDestructors,
        retType.fromWireType.bind(retType),
        instType?.toWireType.bind(instType)
    ];
    for(var i = 2; i < argCount; ++i){
        var argType = argTypes[i];
        closureArgs.push(argType.toWireType.bind(argType));
    }
    if (!needsDestructorStack) {
        for(var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i)if (argTypes[i].destructorFunction !== null) closureArgs.push(argTypes[i].destructorFunction);
    }
    let invokerFactory = $87c43a515e8f090f$var$createJsInvoker(argTypes, isClassMethodFunc, returns, isAsync);
    var invokerFn = invokerFactory(...closureArgs);
    return $87c43a515e8f090f$var$createNamedFunction(humanName, invokerFn);
}
var $87c43a515e8f090f$var$__embind_register_class_constructor = (rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor)=>{
    var rawArgTypes = $87c43a515e8f090f$var$heap32VectorToArray(argCount, rawArgTypesAddr);
    invoker = $87c43a515e8f090f$var$embind__requireFunction(invokerSignature, invoker);
    $87c43a515e8f090f$var$whenDependentTypesAreResolved([], [
        rawClassType
    ], (classType)=>{
        classType = classType[0];
        var humanName = `constructor ${classType.name}`;
        if (undefined === classType.registeredClass.constructor_body) classType.registeredClass.constructor_body = [];
        if (undefined !== classType.registeredClass.constructor_body[argCount - 1]) throw new $87c43a515e8f090f$var$BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        classType.registeredClass.constructor_body[argCount - 1] = ()=>{
            $87c43a515e8f090f$var$throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes);
        };
        $87c43a515e8f090f$var$whenDependentTypesAreResolved([], rawArgTypes, (argTypes)=>{
            argTypes.splice(1, 0, null);
            classType.registeredClass.constructor_body[argCount - 1] = $87c43a515e8f090f$var$craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
            return [];
        });
        return [];
    });
};
var $87c43a515e8f090f$var$getFunctionName = (signature)=>{
    signature = signature.trim();
    const argsIndex = signature.indexOf("(");
    if (argsIndex === -1) return signature;
    return signature.slice(0, argsIndex);
};
var $87c43a515e8f090f$var$__embind_register_class_function = (rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual, isAsync, isNonnullReturn)=>{
    var rawArgTypes = $87c43a515e8f090f$var$heap32VectorToArray(argCount, rawArgTypesAddr);
    methodName = $87c43a515e8f090f$var$AsciiToString(methodName);
    methodName = $87c43a515e8f090f$var$getFunctionName(methodName);
    rawInvoker = $87c43a515e8f090f$var$embind__requireFunction(invokerSignature, rawInvoker, isAsync);
    $87c43a515e8f090f$var$whenDependentTypesAreResolved([], [
        rawClassType
    ], (classType)=>{
        classType = classType[0];
        var humanName = `${classType.name}.${methodName}`;
        if (methodName.startsWith("@@")) methodName = Symbol[methodName.substring(2)];
        if (isPureVirtual) classType.registeredClass.pureVirtualFunctions.push(methodName);
        function unboundTypesHandler() {
            $87c43a515e8f090f$var$throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes);
        }
        var proto = classType.registeredClass.instancePrototype;
        var method = proto[methodName];
        if (undefined === method || undefined === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
            unboundTypesHandler.argCount = argCount - 2;
            unboundTypesHandler.className = classType.name;
            proto[methodName] = unboundTypesHandler;
        } else {
            $87c43a515e8f090f$var$ensureOverloadTable(proto, methodName, humanName);
            proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
        }
        $87c43a515e8f090f$var$whenDependentTypesAreResolved([], rawArgTypes, (argTypes)=>{
            var memberFunction = $87c43a515e8f090f$var$craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
            if (undefined === proto[methodName].overloadTable) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
            } else proto[methodName].overloadTable[argCount - 2] = memberFunction;
            return [];
        });
        return [];
    });
};
var $87c43a515e8f090f$var$emval_freelist = [];
var $87c43a515e8f090f$var$emval_handles = [
    0,
    1,
    ,
    1,
    null,
    1,
    true,
    1,
    false,
    1
];
var $87c43a515e8f090f$var$__emval_decref = (handle)=>{
    if (handle > 9 && 0 === --$87c43a515e8f090f$var$emval_handles[handle + 1]) {
        $87c43a515e8f090f$var$emval_handles[handle] = undefined;
        $87c43a515e8f090f$var$emval_freelist.push(handle);
    }
};
var $87c43a515e8f090f$var$Emval = {
    toValue: (handle)=>{
        if (!handle) $87c43a515e8f090f$var$throwBindingError(`Cannot use deleted val. handle = ${handle}`);
        return $87c43a515e8f090f$var$emval_handles[handle];
    },
    toHandle: (value)=>{
        switch(value){
            case undefined:
                return 2;
            case null:
                return 4;
            case true:
                return 6;
            case false:
                return 8;
            default:
                {
                    const handle = $87c43a515e8f090f$var$emval_freelist.pop() || $87c43a515e8f090f$var$emval_handles.length;
                    $87c43a515e8f090f$var$emval_handles[handle] = value;
                    $87c43a515e8f090f$var$emval_handles[handle + 1] = 1;
                    return handle;
                }
        }
    }
};
var $87c43a515e8f090f$var$EmValType = {
    name: "emscripten::val",
    fromWireType: (handle)=>{
        var rv = $87c43a515e8f090f$var$Emval.toValue(handle);
        $87c43a515e8f090f$var$__emval_decref(handle);
        return rv;
    },
    toWireType: (destructors, value)=>$87c43a515e8f090f$var$Emval.toHandle(value),
    readValueFromPointer: $87c43a515e8f090f$var$readPointer,
    destructorFunction: null
};
var $87c43a515e8f090f$var$__embind_register_emval = (rawType)=>$87c43a515e8f090f$var$registerType(rawType, $87c43a515e8f090f$var$EmValType);
var $87c43a515e8f090f$var$floatReadValueFromPointer = (name, width)=>{
    switch(width){
        case 4:
            return function(pointer) {
                return this.fromWireType($87c43a515e8f090f$var$HEAPF32[pointer >> 2]);
            };
        case 8:
            return function(pointer) {
                return this.fromWireType($87c43a515e8f090f$var$HEAPF64[pointer >> 3]);
            };
        default:
            throw new TypeError(`invalid float width (${width}): ${name}`);
    }
};
var $87c43a515e8f090f$var$__embind_register_float = (rawType, name, size)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    $87c43a515e8f090f$var$registerType(rawType, {
        name: name,
        fromWireType: (value)=>value,
        toWireType: (destructors, value)=>value,
        readValueFromPointer: $87c43a515e8f090f$var$floatReadValueFromPointer(name, size),
        destructorFunction: null
    });
};
var $87c43a515e8f090f$var$__embind_register_function = (name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync, isNonnullReturn)=>{
    var argTypes = $87c43a515e8f090f$var$heap32VectorToArray(argCount, rawArgTypesAddr);
    name = $87c43a515e8f090f$var$AsciiToString(name);
    name = $87c43a515e8f090f$var$getFunctionName(name);
    rawInvoker = $87c43a515e8f090f$var$embind__requireFunction(signature, rawInvoker, isAsync);
    $87c43a515e8f090f$var$exposePublicSymbol(name, function() {
        $87c43a515e8f090f$var$throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes);
    }, argCount - 1);
    $87c43a515e8f090f$var$whenDependentTypesAreResolved([], argTypes, (argTypes)=>{
        var invokerArgsArray = [
            argTypes[0],
            null
        ].concat(argTypes.slice(1));
        $87c43a515e8f090f$var$replacePublicSymbol(name, $87c43a515e8f090f$var$craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn, isAsync), argCount - 1);
        return [];
    });
};
var $87c43a515e8f090f$var$__embind_register_integer = (primitiveType, name, size, minRange, maxRange)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    const isUnsignedType = minRange === 0;
    let fromWireType = (value)=>value;
    if (isUnsignedType) {
        var bitshift = 32 - 8 * size;
        fromWireType = (value)=>value << bitshift >>> bitshift;
        maxRange = fromWireType(maxRange);
    }
    $87c43a515e8f090f$var$registerType(primitiveType, {
        name: name,
        fromWireType: fromWireType,
        toWireType: (destructors, value)=>value,
        readValueFromPointer: $87c43a515e8f090f$var$integerReadValueFromPointer(name, size, minRange !== 0),
        destructorFunction: null
    });
};
var $87c43a515e8f090f$var$__embind_register_memory_view = (rawType, dataTypeIndex, name)=>{
    var typeMapping = [
        Int8Array,
        Uint8Array,
        Int16Array,
        Uint16Array,
        Int32Array,
        Uint32Array,
        Float32Array,
        Float64Array,
        BigInt64Array,
        BigUint64Array
    ];
    var TA = typeMapping[dataTypeIndex];
    function decodeMemoryView(handle) {
        var size = $87c43a515e8f090f$var$HEAPU32[handle >> 2];
        var data = $87c43a515e8f090f$var$HEAPU32[handle + 4 >> 2];
        return new TA($87c43a515e8f090f$var$HEAP8.buffer, data, size);
    }
    name = $87c43a515e8f090f$var$AsciiToString(name);
    $87c43a515e8f090f$var$registerType(rawType, {
        name: name,
        fromWireType: decodeMemoryView,
        readValueFromPointer: decodeMemoryView
    }, {
        ignoreDuplicateRegistrations: true
    });
};
var $87c43a515e8f090f$var$stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
    if (!(maxBytesToWrite > 0)) return 0;
    var startIdx = outIdx;
    var endIdx = outIdx + maxBytesToWrite - 1;
    for(var i = 0; i < str.length; ++i){
        var u = str.codePointAt(i);
        if (u <= 127) {
            if (outIdx >= endIdx) break;
            heap[outIdx++] = u;
        } else if (u <= 2047) {
            if (outIdx + 1 >= endIdx) break;
            heap[outIdx++] = 192 | u >> 6;
            heap[outIdx++] = 128 | u & 63;
        } else if (u <= 65535) {
            if (outIdx + 2 >= endIdx) break;
            heap[outIdx++] = 224 | u >> 12;
            heap[outIdx++] = 128 | u >> 6 & 63;
            heap[outIdx++] = 128 | u & 63;
        } else {
            if (outIdx + 3 >= endIdx) break;
            heap[outIdx++] = 240 | u >> 18;
            heap[outIdx++] = 128 | u >> 12 & 63;
            heap[outIdx++] = 128 | u >> 6 & 63;
            heap[outIdx++] = 128 | u & 63;
            i++;
        }
    }
    heap[outIdx] = 0;
    return outIdx - startIdx;
};
var $87c43a515e8f090f$var$stringToUTF8 = (str, outPtr, maxBytesToWrite)=>$87c43a515e8f090f$var$stringToUTF8Array(str, $87c43a515e8f090f$var$HEAPU8, outPtr, maxBytesToWrite);
var $87c43a515e8f090f$var$lengthBytesUTF8 = (str)=>{
    var len = 0;
    for(var i = 0; i < str.length; ++i){
        var c = str.charCodeAt(i);
        if (c <= 127) len++;
        else if (c <= 2047) len += 2;
        else if (c >= 55296 && c <= 57343) {
            len += 4;
            ++i;
        } else len += 3;
    }
    return len;
};
var $87c43a515e8f090f$var$UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder : undefined;
var $87c43a515e8f090f$var$findStringEnd = (heapOrArray, idx, maxBytesToRead, ignoreNul)=>{
    var maxIdx = idx + maxBytesToRead;
    if (ignoreNul) return maxIdx;
    while(heapOrArray[idx] && !(idx >= maxIdx))++idx;
    return idx;
};
var $87c43a515e8f090f$var$UTF8ArrayToString = (heapOrArray, idx = 0, maxBytesToRead, ignoreNul)=>{
    var endPtr = $87c43a515e8f090f$var$findStringEnd(heapOrArray, idx, maxBytesToRead, ignoreNul);
    if (endPtr - idx > 16 && heapOrArray.buffer && $87c43a515e8f090f$var$UTF8Decoder) return $87c43a515e8f090f$var$UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
    var str = "";
    while(idx < endPtr){
        var u0 = heapOrArray[idx++];
        if (!(u0 & 128)) {
            str += String.fromCharCode(u0);
            continue;
        }
        var u1 = heapOrArray[idx++] & 63;
        if ((u0 & 224) == 192) {
            str += String.fromCharCode((u0 & 31) << 6 | u1);
            continue;
        }
        var u2 = heapOrArray[idx++] & 63;
        if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
        else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
        if (u0 < 65536) str += String.fromCharCode(u0);
        else {
            var ch = u0 - 65536;
            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
        }
    }
    return str;
};
var $87c43a515e8f090f$var$UTF8ToString = (ptr, maxBytesToRead, ignoreNul)=>ptr ? $87c43a515e8f090f$var$UTF8ArrayToString($87c43a515e8f090f$var$HEAPU8, ptr, maxBytesToRead, ignoreNul) : "";
var $87c43a515e8f090f$var$__embind_register_std_string = (rawType, name)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    var stdStringIsUTF8 = true;
    $87c43a515e8f090f$var$registerType(rawType, {
        name: name,
        fromWireType (value) {
            var length = $87c43a515e8f090f$var$HEAPU32[value >> 2];
            var payload = value + 4;
            var str;
            if (stdStringIsUTF8) str = $87c43a515e8f090f$var$UTF8ToString(payload, length, true);
            else {
                str = "";
                for(var i = 0; i < length; ++i)str += String.fromCharCode($87c43a515e8f090f$var$HEAPU8[payload + i]);
            }
            $87c43a515e8f090f$var$_free(value);
            return str;
        },
        toWireType (destructors, value) {
            if (value instanceof ArrayBuffer) value = new Uint8Array(value);
            var length;
            var valueIsOfTypeString = typeof value == "string";
            if (!(valueIsOfTypeString || ArrayBuffer.isView(value) && value.BYTES_PER_ELEMENT == 1)) $87c43a515e8f090f$var$throwBindingError("Cannot pass non-string to std::string");
            if (stdStringIsUTF8 && valueIsOfTypeString) length = $87c43a515e8f090f$var$lengthBytesUTF8(value);
            else length = value.length;
            var base = $87c43a515e8f090f$var$_malloc(4 + length + 1);
            var ptr = base + 4;
            $87c43a515e8f090f$var$HEAPU32[base >> 2] = length;
            if (valueIsOfTypeString) {
                if (stdStringIsUTF8) $87c43a515e8f090f$var$stringToUTF8(value, ptr, length + 1);
                else for(var i = 0; i < length; ++i){
                    var charCode = value.charCodeAt(i);
                    if (charCode > 255) {
                        $87c43a515e8f090f$var$_free(base);
                        $87c43a515e8f090f$var$throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                    }
                    $87c43a515e8f090f$var$HEAPU8[ptr + i] = charCode;
                }
            } else $87c43a515e8f090f$var$HEAPU8.set(value, ptr);
            if (destructors !== null) destructors.push($87c43a515e8f090f$var$_free, base);
            return base;
        },
        readValueFromPointer: $87c43a515e8f090f$var$readPointer,
        destructorFunction (ptr) {
            $87c43a515e8f090f$var$_free(ptr);
        }
    });
};
var $87c43a515e8f090f$var$UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : undefined;
var $87c43a515e8f090f$var$UTF16ToString = (ptr, maxBytesToRead, ignoreNul)=>{
    var idx = ptr >> 1;
    var endIdx = $87c43a515e8f090f$var$findStringEnd($87c43a515e8f090f$var$HEAPU16, idx, maxBytesToRead / 2, ignoreNul);
    if (endIdx - idx > 16 && $87c43a515e8f090f$var$UTF16Decoder) return $87c43a515e8f090f$var$UTF16Decoder.decode($87c43a515e8f090f$var$HEAPU16.subarray(idx, endIdx));
    var str = "";
    for(var i = idx; i < endIdx; ++i){
        var codeUnit = $87c43a515e8f090f$var$HEAPU16[i];
        str += String.fromCharCode(codeUnit);
    }
    return str;
};
var $87c43a515e8f090f$var$stringToUTF16 = (str, outPtr, maxBytesToWrite)=>{
    maxBytesToWrite ??= 2147483647;
    if (maxBytesToWrite < 2) return 0;
    maxBytesToWrite -= 2;
    var startPtr = outPtr;
    var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
    for(var i = 0; i < numCharsToWrite; ++i){
        var codeUnit = str.charCodeAt(i);
        $87c43a515e8f090f$var$HEAP16[outPtr >> 1] = codeUnit;
        outPtr += 2;
    }
    $87c43a515e8f090f$var$HEAP16[outPtr >> 1] = 0;
    return outPtr - startPtr;
};
var $87c43a515e8f090f$var$lengthBytesUTF16 = (str)=>str.length * 2;
var $87c43a515e8f090f$var$UTF32ToString = (ptr, maxBytesToRead, ignoreNul)=>{
    var str = "";
    var startIdx = ptr >> 2;
    for(var i = 0; !(i >= maxBytesToRead / 4); i++){
        var utf32 = $87c43a515e8f090f$var$HEAPU32[startIdx + i];
        if (!utf32 && !ignoreNul) break;
        str += String.fromCodePoint(utf32);
    }
    return str;
};
var $87c43a515e8f090f$var$stringToUTF32 = (str, outPtr, maxBytesToWrite)=>{
    maxBytesToWrite ??= 2147483647;
    if (maxBytesToWrite < 4) return 0;
    var startPtr = outPtr;
    var endPtr = startPtr + maxBytesToWrite - 4;
    for(var i = 0; i < str.length; ++i){
        var codePoint = str.codePointAt(i);
        if (codePoint > 65535) i++;
        $87c43a515e8f090f$var$HEAP32[outPtr >> 2] = codePoint;
        outPtr += 4;
        if (outPtr + 4 > endPtr) break;
    }
    $87c43a515e8f090f$var$HEAP32[outPtr >> 2] = 0;
    return outPtr - startPtr;
};
var $87c43a515e8f090f$var$lengthBytesUTF32 = (str)=>{
    var len = 0;
    for(var i = 0; i < str.length; ++i){
        var codePoint = str.codePointAt(i);
        if (codePoint > 65535) i++;
        len += 4;
    }
    return len;
};
var $87c43a515e8f090f$var$__embind_register_std_wstring = (rawType, charSize, name)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    var decodeString, encodeString, lengthBytesUTF;
    if (charSize === 2) {
        decodeString = $87c43a515e8f090f$var$UTF16ToString;
        encodeString = $87c43a515e8f090f$var$stringToUTF16;
        lengthBytesUTF = $87c43a515e8f090f$var$lengthBytesUTF16;
    } else {
        decodeString = $87c43a515e8f090f$var$UTF32ToString;
        encodeString = $87c43a515e8f090f$var$stringToUTF32;
        lengthBytesUTF = $87c43a515e8f090f$var$lengthBytesUTF32;
    }
    $87c43a515e8f090f$var$registerType(rawType, {
        name: name,
        fromWireType: (value)=>{
            var length = $87c43a515e8f090f$var$HEAPU32[value >> 2];
            var str = decodeString(value + 4, length * charSize, true);
            $87c43a515e8f090f$var$_free(value);
            return str;
        },
        toWireType: (destructors, value)=>{
            if (!(typeof value == "string")) $87c43a515e8f090f$var$throwBindingError(`Cannot pass non-string to C++ string type ${name}`);
            var length = lengthBytesUTF(value);
            var ptr = $87c43a515e8f090f$var$_malloc(4 + length + charSize);
            $87c43a515e8f090f$var$HEAPU32[ptr >> 2] = length / charSize;
            encodeString(value, ptr + 4, length + charSize);
            if (destructors !== null) destructors.push($87c43a515e8f090f$var$_free, ptr);
            return ptr;
        },
        readValueFromPointer: $87c43a515e8f090f$var$readPointer,
        destructorFunction (ptr) {
            $87c43a515e8f090f$var$_free(ptr);
        }
    });
};
var $87c43a515e8f090f$var$__embind_register_void = (rawType, name)=>{
    name = $87c43a515e8f090f$var$AsciiToString(name);
    $87c43a515e8f090f$var$registerType(rawType, {
        isVoid: true,
        name: name,
        fromWireType: ()=>undefined,
        toWireType: (destructors, o)=>undefined
    });
};
var $87c43a515e8f090f$var$emval_methodCallers = [];
var $87c43a515e8f090f$var$emval_addMethodCaller = (caller)=>{
    var id = $87c43a515e8f090f$var$emval_methodCallers.length;
    $87c43a515e8f090f$var$emval_methodCallers.push(caller);
    return id;
};
var $87c43a515e8f090f$var$requireRegisteredType = (rawType, humanName)=>{
    var impl = $87c43a515e8f090f$var$registeredTypes[rawType];
    if (undefined === impl) $87c43a515e8f090f$var$throwBindingError(`${humanName} has unknown type ${$87c43a515e8f090f$var$getTypeName(rawType)}`);
    return impl;
};
var $87c43a515e8f090f$var$emval_lookupTypes = (argCount, argTypes)=>{
    var a = new Array(argCount);
    for(var i = 0; i < argCount; ++i)a[i] = $87c43a515e8f090f$var$requireRegisteredType($87c43a515e8f090f$var$HEAPU32[argTypes + i * 4 >> 2], `parameter ${i}`);
    return a;
};
var $87c43a515e8f090f$var$emval_returnValue = (toReturnWire, destructorsRef, handle)=>{
    var destructors = [];
    var result = toReturnWire(destructors, handle);
    if (destructors.length) $87c43a515e8f090f$var$HEAPU32[destructorsRef >> 2] = $87c43a515e8f090f$var$Emval.toHandle(destructors);
    return result;
};
var $87c43a515e8f090f$var$emval_symbols = {};
var $87c43a515e8f090f$var$getStringOrSymbol = (address)=>{
    var symbol = $87c43a515e8f090f$var$emval_symbols[address];
    if (symbol === undefined) return $87c43a515e8f090f$var$AsciiToString(address);
    return symbol;
};
var $87c43a515e8f090f$var$__emval_create_invoker = (argCount, argTypesPtr, kind)=>{
    var GenericWireTypeSize = 8;
    var [retType, ...argTypes] = $87c43a515e8f090f$var$emval_lookupTypes(argCount, argTypesPtr);
    var toReturnWire = retType.toWireType.bind(retType);
    var argFromPtr = argTypes.map((type)=>type.readValueFromPointer.bind(type));
    argCount--;
    var captures = {
        toValue: $87c43a515e8f090f$var$Emval.toValue
    };
    var args = argFromPtr.map((argFromPtr, i)=>{
        var captureName = `argFromPtr${i}`;
        captures[captureName] = argFromPtr;
        return `${captureName}(args${i ? "+" + i * GenericWireTypeSize : ""})`;
    });
    var functionBody;
    switch(kind){
        case 0:
            functionBody = "toValue(handle)";
            break;
        case 2:
            functionBody = "new (toValue(handle))";
            break;
        case 3:
            functionBody = "";
            break;
        case 1:
            captures["getStringOrSymbol"] = $87c43a515e8f090f$var$getStringOrSymbol;
            functionBody = "toValue(handle)[getStringOrSymbol(methodName)]";
            break;
    }
    functionBody += `(${args})`;
    if (!retType.isVoid) {
        captures["toReturnWire"] = toReturnWire;
        captures["emval_returnValue"] = $87c43a515e8f090f$var$emval_returnValue;
        functionBody = `return emval_returnValue(toReturnWire, destructorsRef, ${functionBody})`;
    }
    functionBody = `return function (handle, methodName, destructorsRef, args) {\n  ${functionBody}\n  }`;
    var invokerFunction = new Function(Object.keys(captures), functionBody)(...Object.values(captures));
    var functionName = `methodCaller<(${argTypes.map((t)=>t.name)}) => ${retType.name}>`;
    return $87c43a515e8f090f$var$emval_addMethodCaller($87c43a515e8f090f$var$createNamedFunction(functionName, invokerFunction));
};
var $87c43a515e8f090f$var$emval_get_global = ()=>globalThis;
var $87c43a515e8f090f$var$__emval_get_global = (name)=>{
    if (name === 0) return $87c43a515e8f090f$var$Emval.toHandle($87c43a515e8f090f$var$emval_get_global());
    else {
        name = $87c43a515e8f090f$var$getStringOrSymbol(name);
        return $87c43a515e8f090f$var$Emval.toHandle($87c43a515e8f090f$var$emval_get_global()[name]);
    }
};
var $87c43a515e8f090f$var$__emval_get_property = (handle, key)=>{
    handle = $87c43a515e8f090f$var$Emval.toValue(handle);
    key = $87c43a515e8f090f$var$Emval.toValue(key);
    return $87c43a515e8f090f$var$Emval.toHandle(handle[key]);
};
var $87c43a515e8f090f$var$__emval_incref = (handle)=>{
    if (handle > 9) $87c43a515e8f090f$var$emval_handles[handle + 1] += 1;
};
var $87c43a515e8f090f$var$__emval_invoke = (caller, handle, methodName, destructorsRef, args)=>$87c43a515e8f090f$var$emval_methodCallers[caller](handle, methodName, destructorsRef, args);
var $87c43a515e8f090f$var$__emval_new_cstring = (v)=>$87c43a515e8f090f$var$Emval.toHandle($87c43a515e8f090f$var$getStringOrSymbol(v));
var $87c43a515e8f090f$var$__emval_new_object = ()=>$87c43a515e8f090f$var$Emval.toHandle({});
var $87c43a515e8f090f$var$__emval_run_destructors = (handle)=>{
    var destructors = $87c43a515e8f090f$var$Emval.toValue(handle);
    $87c43a515e8f090f$var$runDestructors(destructors);
    $87c43a515e8f090f$var$__emval_decref(handle);
};
var $87c43a515e8f090f$var$__emval_set_property = (handle, key, value)=>{
    handle = $87c43a515e8f090f$var$Emval.toValue(handle);
    key = $87c43a515e8f090f$var$Emval.toValue(key);
    value = $87c43a515e8f090f$var$Emval.toValue(value);
    handle[key] = value;
};
var $87c43a515e8f090f$var$__tzset_js = (timezone, daylight, std_name, dst_name)=>{
    var currentYear = (new Date).getFullYear();
    var winter = new Date(currentYear, 0, 1);
    var summer = new Date(currentYear, 6, 1);
    var winterOffset = winter.getTimezoneOffset();
    var summerOffset = summer.getTimezoneOffset();
    var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
    $87c43a515e8f090f$var$HEAPU32[timezone >> 2] = stdTimezoneOffset * 60;
    $87c43a515e8f090f$var$HEAP32[daylight >> 2] = Number(winterOffset != summerOffset);
    var extractZone = (timezoneOffset)=>{
        var sign = timezoneOffset >= 0 ? "-" : "+";
        var absOffset = Math.abs(timezoneOffset);
        var hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
        var minutes = String(absOffset % 60).padStart(2, "0");
        return `UTC${sign}${hours}${minutes}`;
    };
    var winterName = extractZone(winterOffset);
    var summerName = extractZone(summerOffset);
    if (summerOffset < winterOffset) {
        $87c43a515e8f090f$var$stringToUTF8(winterName, std_name, 17);
        $87c43a515e8f090f$var$stringToUTF8(summerName, dst_name, 17);
    } else {
        $87c43a515e8f090f$var$stringToUTF8(winterName, dst_name, 17);
        $87c43a515e8f090f$var$stringToUTF8(summerName, std_name, 17);
    }
};
var $87c43a515e8f090f$var$getHeapMax = ()=>2147483648;
var $87c43a515e8f090f$var$alignMemory = (size, alignment)=>Math.ceil(size / alignment) * alignment;
var $87c43a515e8f090f$var$growMemory = (size)=>{
    var oldHeapSize = $87c43a515e8f090f$var$wasmMemory.buffer.byteLength;
    var pages = (size - oldHeapSize + 65535) / 65536 | 0;
    try {
        $87c43a515e8f090f$var$wasmMemory.grow(pages);
        $87c43a515e8f090f$var$updateMemoryViews();
        return 1;
    } catch (e) {}
};
var $87c43a515e8f090f$var$_emscripten_resize_heap = (requestedSize)=>{
    var oldSize = $87c43a515e8f090f$var$HEAPU8.length;
    requestedSize >>>= 0;
    var maxHeapSize = $87c43a515e8f090f$var$getHeapMax();
    if (requestedSize > maxHeapSize) return false;
    for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
        var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
        var newSize = Math.min(maxHeapSize, $87c43a515e8f090f$var$alignMemory(Math.max(requestedSize, overGrownHeapSize), 65536));
        var replacement = $87c43a515e8f090f$var$growMemory(newSize);
        if (replacement) return true;
    }
    return false;
};
var $87c43a515e8f090f$var$ENV = {};
var $87c43a515e8f090f$var$getExecutableName = ()=>$87c43a515e8f090f$var$thisProgram || "./this.program";
var $87c43a515e8f090f$var$getEnvStrings = ()=>{
    if (!$87c43a515e8f090f$var$getEnvStrings.strings) {
        var lang = (typeof navigator == "object" && navigator.language || "C").replace("-", "_") + ".UTF-8";
        var env = {
            USER: "web_user",
            LOGNAME: "web_user",
            PATH: "/",
            PWD: "/",
            HOME: "/home/web_user",
            LANG: lang,
            _: $87c43a515e8f090f$var$getExecutableName()
        };
        for(var x in $87c43a515e8f090f$var$ENV)if ($87c43a515e8f090f$var$ENV[x] === undefined) delete env[x];
        else env[x] = $87c43a515e8f090f$var$ENV[x];
        var strings = [];
        for(var x in env)strings.push(`${x}=${env[x]}`);
        $87c43a515e8f090f$var$getEnvStrings.strings = strings;
    }
    return $87c43a515e8f090f$var$getEnvStrings.strings;
};
var $87c43a515e8f090f$var$_environ_get = (__environ, environ_buf)=>{
    var bufSize = 0;
    var envp = 0;
    for (var string of $87c43a515e8f090f$var$getEnvStrings()){
        var ptr = environ_buf + bufSize;
        $87c43a515e8f090f$var$HEAPU32[__environ + envp >> 2] = ptr;
        bufSize += $87c43a515e8f090f$var$stringToUTF8(string, ptr, Infinity) + 1;
        envp += 4;
    }
    return 0;
};
var $87c43a515e8f090f$var$_environ_sizes_get = (penviron_count, penviron_buf_size)=>{
    var strings = $87c43a515e8f090f$var$getEnvStrings();
    $87c43a515e8f090f$var$HEAPU32[penviron_count >> 2] = strings.length;
    var bufSize = 0;
    for (var string of strings)bufSize += $87c43a515e8f090f$var$lengthBytesUTF8(string) + 1;
    $87c43a515e8f090f$var$HEAPU32[penviron_buf_size >> 2] = bufSize;
    return 0;
};
var $87c43a515e8f090f$var$_fd_close = (fd)=>52;
var $87c43a515e8f090f$var$INT53_MAX = 9007199254740992;
var $87c43a515e8f090f$var$INT53_MIN = -9007199254740992;
var $87c43a515e8f090f$var$bigintToI53Checked = (num)=>num < $87c43a515e8f090f$var$INT53_MIN || num > $87c43a515e8f090f$var$INT53_MAX ? NaN : Number(num);
function $87c43a515e8f090f$var$_fd_seek(fd, offset, whence, newOffset) {
    offset = $87c43a515e8f090f$var$bigintToI53Checked(offset);
    return 70;
}
var $87c43a515e8f090f$var$printCharBuffers = [
    null,
    [],
    []
];
var $87c43a515e8f090f$var$printChar = (stream, curr)=>{
    var buffer = $87c43a515e8f090f$var$printCharBuffers[stream];
    if (curr === 0 || curr === 10) {
        (stream === 1 ? $87c43a515e8f090f$var$out : $87c43a515e8f090f$var$err)($87c43a515e8f090f$var$UTF8ArrayToString(buffer));
        buffer.length = 0;
    } else buffer.push(curr);
};
var $87c43a515e8f090f$var$_fd_write = (fd, iov, iovcnt, pnum)=>{
    var num = 0;
    for(var i = 0; i < iovcnt; i++){
        var ptr = $87c43a515e8f090f$var$HEAPU32[iov >> 2];
        var len = $87c43a515e8f090f$var$HEAPU32[iov + 4 >> 2];
        iov += 8;
        for(var j = 0; j < len; j++)$87c43a515e8f090f$var$printChar(fd, $87c43a515e8f090f$var$HEAPU8[ptr + j]);
        num += len;
    }
    $87c43a515e8f090f$var$HEAPU32[pnum >> 2] = num;
    return 0;
};
$87c43a515e8f090f$var$init_ClassHandle();
$87c43a515e8f090f$var$init_RegisteredPointer();
if ($87c43a515e8f090f$var$Module["noExitRuntime"]) $87c43a515e8f090f$var$noExitRuntime = $87c43a515e8f090f$var$Module["noExitRuntime"];
if ($87c43a515e8f090f$var$Module["print"]) $87c43a515e8f090f$var$out = $87c43a515e8f090f$var$Module["print"];
if ($87c43a515e8f090f$var$Module["printErr"]) $87c43a515e8f090f$var$err = $87c43a515e8f090f$var$Module["printErr"];
if ($87c43a515e8f090f$var$Module["wasmBinary"]) $87c43a515e8f090f$var$wasmBinary = $87c43a515e8f090f$var$Module["wasmBinary"];
if ($87c43a515e8f090f$var$Module["arguments"]) $87c43a515e8f090f$var$arguments_ = $87c43a515e8f090f$var$Module["arguments"];
if ($87c43a515e8f090f$var$Module["thisProgram"]) $87c43a515e8f090f$var$thisProgram = $87c43a515e8f090f$var$Module["thisProgram"];
var $87c43a515e8f090f$var$___getTypeName, $87c43a515e8f090f$var$_frontendMain, $87c43a515e8f090f$var$_malloc, $87c43a515e8f090f$var$_free, $87c43a515e8f090f$var$__emscripten_stack_restore, $87c43a515e8f090f$var$__emscripten_stack_alloc, $87c43a515e8f090f$var$_emscripten_stack_get_current;
function $87c43a515e8f090f$var$assignWasmExports(wasmExports) {
    $87c43a515e8f090f$var$___getTypeName = wasmExports["__getTypeName"];
    $87c43a515e8f090f$var$Module["_frontendMain"] = $87c43a515e8f090f$var$_frontendMain = wasmExports["frontendMain"];
    $87c43a515e8f090f$var$_malloc = wasmExports["malloc"];
    $87c43a515e8f090f$var$_free = wasmExports["free"];
    $87c43a515e8f090f$var$__emscripten_stack_restore = wasmExports["_emscripten_stack_restore"];
    $87c43a515e8f090f$var$__emscripten_stack_alloc = wasmExports["_emscripten_stack_alloc"];
    $87c43a515e8f090f$var$_emscripten_stack_get_current = wasmExports["emscripten_stack_get_current"];
}
var $87c43a515e8f090f$var$wasmImports = {
    __cxa_throw: $87c43a515e8f090f$var$___cxa_throw,
    _abort_js: $87c43a515e8f090f$var$__abort_js,
    _embind_register_bigint: $87c43a515e8f090f$var$__embind_register_bigint,
    _embind_register_bool: $87c43a515e8f090f$var$__embind_register_bool,
    _embind_register_class: $87c43a515e8f090f$var$__embind_register_class,
    _embind_register_class_constructor: $87c43a515e8f090f$var$__embind_register_class_constructor,
    _embind_register_class_function: $87c43a515e8f090f$var$__embind_register_class_function,
    _embind_register_emval: $87c43a515e8f090f$var$__embind_register_emval,
    _embind_register_float: $87c43a515e8f090f$var$__embind_register_float,
    _embind_register_function: $87c43a515e8f090f$var$__embind_register_function,
    _embind_register_integer: $87c43a515e8f090f$var$__embind_register_integer,
    _embind_register_memory_view: $87c43a515e8f090f$var$__embind_register_memory_view,
    _embind_register_std_string: $87c43a515e8f090f$var$__embind_register_std_string,
    _embind_register_std_wstring: $87c43a515e8f090f$var$__embind_register_std_wstring,
    _embind_register_void: $87c43a515e8f090f$var$__embind_register_void,
    _emval_create_invoker: $87c43a515e8f090f$var$__emval_create_invoker,
    _emval_decref: $87c43a515e8f090f$var$__emval_decref,
    _emval_get_global: $87c43a515e8f090f$var$__emval_get_global,
    _emval_get_property: $87c43a515e8f090f$var$__emval_get_property,
    _emval_incref: $87c43a515e8f090f$var$__emval_incref,
    _emval_invoke: $87c43a515e8f090f$var$__emval_invoke,
    _emval_new_cstring: $87c43a515e8f090f$var$__emval_new_cstring,
    _emval_new_object: $87c43a515e8f090f$var$__emval_new_object,
    _emval_run_destructors: $87c43a515e8f090f$var$__emval_run_destructors,
    _emval_set_property: $87c43a515e8f090f$var$__emval_set_property,
    _tzset_js: $87c43a515e8f090f$var$__tzset_js,
    emscripten_resize_heap: $87c43a515e8f090f$var$_emscripten_resize_heap,
    environ_get: $87c43a515e8f090f$var$_environ_get,
    environ_sizes_get: $87c43a515e8f090f$var$_environ_sizes_get,
    fd_close: $87c43a515e8f090f$var$_fd_close,
    fd_seek: $87c43a515e8f090f$var$_fd_seek,
    fd_write: $87c43a515e8f090f$var$_fd_write
};
var $87c43a515e8f090f$var$wasmExports;
$87c43a515e8f090f$var$createWasm();
function $87c43a515e8f090f$var$run() {
    if ($87c43a515e8f090f$var$runDependencies > 0) {
        $87c43a515e8f090f$var$dependenciesFulfilled = $87c43a515e8f090f$var$run;
        return;
    }
    $87c43a515e8f090f$var$preRun();
    if ($87c43a515e8f090f$var$runDependencies > 0) {
        $87c43a515e8f090f$var$dependenciesFulfilled = $87c43a515e8f090f$var$run;
        return;
    }
    function doRun() {
        $87c43a515e8f090f$var$Module["calledRun"] = true;
        if ($87c43a515e8f090f$var$ABORT) return;
        $87c43a515e8f090f$var$initRuntime();
        $87c43a515e8f090f$var$Module["onRuntimeInitialized"]?.();
        $87c43a515e8f090f$var$postRun();
    }
    if ($87c43a515e8f090f$var$Module["setStatus"]) {
        $87c43a515e8f090f$var$Module["setStatus"]("Running...");
        setTimeout(()=>{
            setTimeout(()=>$87c43a515e8f090f$var$Module["setStatus"](""), 1);
            doRun();
        }, 1);
    } else doRun();
}
function $87c43a515e8f090f$var$preInit() {
    if ($87c43a515e8f090f$var$Module["preInit"]) {
        if (typeof $87c43a515e8f090f$var$Module["preInit"] == "function") $87c43a515e8f090f$var$Module["preInit"] = [
            $87c43a515e8f090f$var$Module["preInit"]
        ];
        while($87c43a515e8f090f$var$Module["preInit"].length > 0)$87c43a515e8f090f$var$Module["preInit"].shift()();
    }
}
$87c43a515e8f090f$var$preInit();
$87c43a515e8f090f$var$run();


//# sourceMappingURL=static.44aa4603.js.map
